import { useTranslation } from "react-i18next";
import { IAccountAppealSubmissionInfo } from "../../model/interface";
import { Input, Label } from "@fluentui/react-components";
import { CheckmarkCircle48Filled } from "@fluentui/react-icons";
import { EMPTY_GUID } from "../../constants/constants";
import './AccountAppealSubmission.scss';

export default function AccountAppealSubmission(props: IAccountAppealSubmissionInfo) {
    const { t } = useTranslation();

    const getOverviewSubHeader = () => { 
        if(props.isUpdatedSubmission) { 
            return t('Appeal.Common.appeal-updated');
        }
        else if(props.isNewSubmission) {
            return t('Appeal.Common.appeal-submitted');
        }
        return t('Appeal.Common.appeal-already-submitted');
    }

    return (
        <div>
            <div className="form-overview__submission" role="alert">
                <div><CheckmarkCircle48Filled /></div>
                <h1 className="form-overview__header"> {t('Common.thank-you')}</h1>
                <p className="form-overview__paragraph" >{getOverviewSubHeader()}</p>
            </div>
            <div className="form-fields">
                {props.appealNumber !== EMPTY_GUID &&
                    <div className="appeal-number-submission">
                        <Label id="appealNumberSubmissionLabel">{t('Appeal.Common.appeal-number')}</Label>
                        <Input
                            className="appeal-number"
                            id="appealNumberSubmission"
                            aria-labelledby="appealNumberSubmissionLabel"
                            data-testid="appealNumberSubmission"
                            type="text"
                            disabled
                            value={props.appealNumber ? props.appealNumber : t('Appeal.Common.appeal-number')}
                        />
                    </div>
                }
                <div className="appeal-date-submission">
                    <Label id="appealDateLabel">{t('Appeal.Common.date-of-appeal')}</Label>
                    <Input
                        id="appealDate"
                        aria-labelledby="appealDateLabel"
                        data-testid="appealDate"
                        type="text"
                        disabled
                        value={props.appealDate ? props.appealDate : t('Appeal.Common.date-of-appeal')}
                    />
                </div>
                <div className="user-id-submission">
                    <Label id="suspendedUserIdLabel">{t('Appeal.Account.suspended-user-id')}</Label>
                    <Input
                        id="suspendedUserId"
                        aria-labelledby="suspendedUserIdLabel"
                        data-testid="suspendedUserId"
                        type="text"
                        disabled
                        value={props.userId ? props.userId : t('Appeal.Account.suspended-user-id')}
                    />
                </div>
                <div className="name-submission">
                    <Label id="nameLabel">{t('Appeal.Account.full-name')}</Label>
                    <Input
                        id="name"
                        aria-labelledby="nameLabel"
                        data-testid="name"
                        type="text"
                        disabled
                        value={props.appealerName ? props.appealerName : t('Appeal.Account.full-name')}
                    />
                </div>
                <div className="contact-email-submission">
                    <Label id="contactEmailLabel">{t('Appeal.Account.contact-email-address')}</Label>
                    <Input
                        id="contactEmail"
                        aria-labelledby="contactEmailLabel"
                        data-testid="contactEmail"
                        type="email"
                        disabled
                        value={props.contactEmail ? props.contactEmail : t('Appeal.Account.contact-email-address')}
                    />
                </div>
                <div className="submission-sub-text">
                    <span className="submission-sub-text__remarks">{t('Appeal.Common.submission-remarks-one')}</span>
                    <span className="submission-sub-text__remarks">{t('Appeal.Common.submission-remarks-two')}</span>
                </div>
            </div>
        </div>
    );
};
